import { TicketCreate, Ticket, TicketOverview } from 'projects/flow-gui-access/views/middlewares/ticket'

module.exports = [
  {
    path: '/ticket/create',
    exact: true,
    component: TicketCreate
  }, {
    path: '/ticket/create/:accessId',
    exact: true,
    component: TicketCreate
  },
  {
    path: '/ticket/wizard/:accessId',
    exact: true,
    component: TicketCreate
  },
  {
    path: '/ticket/create/:accessId/:service',
    exact: true,
    component: TicketCreate
  }, {
    path: '/ticket',
    exact: true,
    component: TicketOverview
  }, {
    path: '/ticket/:ticketId',
    exact: true,
    component: Ticket
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/ticket.js